import React from "react";
import './new-assessment.scss';
import Loading from "../../common/loading/loading";
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import FilterComponent from "../filter/filter";
import { Modal, ModalBody } from "reactstrap";
import QuestionList from "../../tests-v3/reports/questions-list/all-questions";
import TestApi from "../../../apis/test";
import CommonUtils from "../../../utility/common-utilities";

class NewAssessment extends React.Component {

    state = {
        isLoading: false,
        questions: [],
        payload: {
            medium: '',
            class: '',
            board: ''
        }
    }

    onClickBack() {
        this.props?.delegate?.hideNewAssessment && this.props.delegate.hideNewAssessment()
    }


    showQuestionList = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QuestionList selectedItem={{ questions: this.state.questions.length, questionsList: this.state.questions, time: this.state.duration }} type='JIGYAGA_ASSESSMENT' delegate={this} close={this.hideQuestionList} />
                </ModalBody>
            </Modal>
        )
    }


    onClickInfo = () => {
        if (!this.state.payload.class || !this.state.payload?.medium) return
        this.setState({ showQuestionList: true })
    }

    getAssessmentAllQuestionsList() {

        if (!this.state.payload.class || !this.state.payload?.medium) return


        let payload = {}

        payload.board = this.state.payload?.board
        payload.class = this.state.payload?.class
        payload.medium = this.state.payload?.medium
        payload.type = 'JIGYASA_ASSESSMENT'

        TestApi.getAssessmentAllQuestionList(payload).then(response => {

            if (response.questions && response.questions.length > 0) {
                response.questions.map(question => {
                    if (!question.mandatoryAttachments) {
                        question.mandatoryAttachments = {
                            video: false,
                            audio: false,
                            image: false
                        }
                    }
                    return question
                })
            }

            this.setState({ questions: response.questions || [], duration: response.duration }, () => {
                // this.showQuestionList(res)
            })

        }).catch(err => {
            console.log(err)
        })
    }


    hideQuestionList = () => {
        this.setState({ showQuestionList: false })
    }


    handleFilter = (payload, reloadQuestion, reloadStudent) => {
        this.setState({ payload }, () => {
            reloadQuestion && this.getAssessmentAllQuestionsList()
        })
    }





    onClickCreate() {


        if (!this.state.questions.length) {
            console.log(this.state.questions)
            return
        }

        let type = "JIGYASA_ASSESSMENT"
        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: type ? type : this.props.type
        }
        payload.approximateQuestions = this.state.questions.length || 0
        payload.approximateTime = this.state.duration || 0

        payload.questions = this.getQuestionPayload(this.state.questions || [])
        let validation = this.validatePayload(payload)

        if (!validation) {
            this.setState({ isCreate: true })
            return
        }

        this.setState({ isLoading: true })

        TestApi.createJigyasaAssessment(payload).then(response => {
            this.saving = false
            // this.setState({ isLoading: false, showPickQuestions: false })
            // let assessment = { ...response.data, ...payload, created: true }
            // if (!assessment.totalUsers) {
            //     this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(assessment, "WHATSAPP")
            // } else {
            // this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(assessment)
            this.props?.delegate?.showSuccessMessage && this.props.delegate.showSuccessMessage()
            // }
            // if (assessment.point) {
            //     this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(assessment.point)
            // }
            // this.props?.delegate?.hideNewTest && this.props.delegate.hideNewTest(true)
        }).catch(err => {

            this.saving = false

            this.setState({ isLoading: false })
        })

    }

    getQuestionPayload(questions) {
        let result = questions.map(item => {
            item.mark = item?.content?.mark || CommonUtils.getMarkByComplexity(item?.content?.complexity)
            delete item.content
            return item
        })
        return result
    }



    validatePayload(payload, leaveQuestions) {
        if (!payload?.board) {
            this.setState({ selectBoardMessage: true })
            return false
        }

        if (!payload?.schoolId) {
            this.setState({ selectSchoolMessage: true })
            return false
        }

        if (!payload?.class) {
            this.setState({ selectClassMessage: true })
            return false
        }

        if (!payload.section) {
            this.setState({ selectSectionMessage: true })
            return false
        }



        // if (!payload.duration) {
        //     this.setState({ errMessage: "Please Select the Duration" })
        //     return false
        // }

        // if (!payload.dueDate) {
        //     this.setState({ selectedDueDateMessage: true })
        //     return false
        // }

        if (!payload.medium) {
            this.setState({ selectedMediumMessage: true })
            return false
        }

        if (!payload?.questions?.length) {
            this.setState({ errMessage: "No Questions Available" })
            return false
        }

        this.setState({ errMessage: "" })
        return true
    }



    render() {
        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className="new-assessment">
                    <div>
                        <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>
                    <div className="row pt-4" >
                        <div className="col screen-title">{this.props?.title || "New Assessment"}</div>
                    </div>
                    <div className='row' style={{ position: "relative" }}>
                        <div className="col-11">
                            <FilterComponent
                                type={this.props.type}
                                onGo={this.handleFilter}
                                delegate={this}
                                isCreate={this.state.isCreate}
                                selectSchoolMessage={this.state.selectSchoolMessage}
                                selectBoardMessage={this.state.selectBoardMessage}
                                selectClassMessage={this.state.selectClassMessage}
                                selectedMediumMessage={this.state.selectedMediumMessage}
                                selectDueDateMessage={this.state.selectDueDateMessage}
                            />
                            {
                                this.state.payload.section && this.state.payload.medium ?
                                    <div className={`create-homework-absolute ${this.state.isAdaptive ? 'create-homework-absolute-adaptive' : ''} 
                                    ${this.props.moreThanOneBoard ? 'create-homework-for-more-than-one-board' : ''}`}>
                                        <div className={`float-right cursor-pointer d-flex align-items-center justify-content-center text-center create-button d-inline-block cw-btn-primary ${this.props.moreThanOneBoard ? 'create-button-for-more-than-one-board' : ''}`} onClick={() => this.onClickCreate()}>
                                            Create
                                        </div>
                                    </div>
                                    :
                                    <></>
                            }

                        </div>

                        {/* <div className="col-1 info-position">
                            <div className="text-center">
                                <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.INFO1)} onClick={this.onClickInfo} />
                            </div>
                        </div> */}
                    </div>

                    {
                        this.state.showQuestionList ? this.showQuestionList() : ""
                    }

                </div>
            </>

        )
    }
}

export default NewAssessment;